import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const CSS_Fonts_Family = () => {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">✍️ CSS Font Family</h1>

      {/* Intro Section with Gradient */}
      <div
        style={{
          background: "linear-gradient(135deg, #d1fae5, #bbf7d0)",
          padding: "1rem",
          borderRadius: "12px",
          marginBottom: "2rem",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#166534", marginBottom: "0.5rem" }}>
          🎨 What is Font Family?
        </h2>
        <p style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
          The <code>font-family</code> property defines the typeface of your
          text. If the first font isn’t available, the browser tries the next
          one as a <strong>fallback</strong>.
        </p>
      </div>

      {/* Generic vs Specific Fonts */}
      <div className="tutorial-section">
        <h2 className="section-title">📘 Generic vs Specific Fonts</h2>
        <p>There are two main types of font families:</p>
        <ul className="tutorial-list">
          <li>
            <strong>Specific fonts</strong> – like Arial, Verdana, Georgia
          </li>
          <li>
            <strong>Generic families</strong> – like serif, sans-serif,
            monospace
          </li>
        </ul>
        <CodeCopyBlock
          code={`p {
  font-family: "Arial", "Helvetica", sans-serif;
}`}
        />
        <p style={{ fontFamily: "Arial, Helvetica, sans-serif" }}>
          👉 Example: This text uses Arial (or Helvetica/sans-serif as
          fallback).
        </p>
      </div>

      {/* Serif vs Sans-serif */}
      <div className="tutorial-section">
        <h2 className="section-title">🔤 Serif vs Sans-Serif</h2>
        <p>
          Serif fonts have decorative strokes, while sans-serif fonts are clean
          and modern.
        </p>
        <CodeCopyBlock
          code={`h1 { font-family: "Times New Roman", serif; }
h2 { font-family: Verdana, sans-serif; }`}
        />
        <h3 style={{ fontFamily: "'Times New Roman', serif" }}>
          This is Times New Roman (Serif)
        </h3>
        <h3 style={{ fontFamily: "Verdana, sans-serif" }}>
          This is Verdana (Sans-serif)
        </h3>
      </div>

      {/* Monospace Example */}
      <div className="tutorial-section">
        <h2 className="section-title">⌨️ Monospace Fonts</h2>
        <p>
          Monospace fonts are often used for code since every character has the
          same width.
        </p>
        <CodeCopyBlock
          code={`code { font-family: "Courier New", monospace; }`}
        />
        <p
          style={{
            fontFamily: "'Courier New', monospace",
            background: "#f3f4f6",
            padding: "0.5rem",
            borderRadius: "6px",
          }}
        >
          Example of monospace text: console.log("Hello World!");
        </p>
      </div>

      {/* Best Practices */}
      <div className="tutorial-section">
        <h2 className="section-title">✅ Best Practices</h2>
        <ul className="tutorial-list">
          <li>Always define multiple fonts with fallbacks.</li>
          <li>
            Wrap multi-word font names in quotes (<code>"Times New Roman"</code>
            ).
          </li>
          <li>Use web-safe fonts for better cross-browser support.</li>
        </ul>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">🚀 Next Steps</h2>
        <p>
          After <strong>Font Family</strong>, explore{" "}
          <a href="/css/fonts-size" className="learn-more">
            CSS Font Size
          </a>{" "}
          to control text sizing more effectively.
        </p>
      </div>
    </div>
  );
};

export default CSS_Fonts_Family;
